<template>
  <div>
    <!-- 轮播图-->
    <carousel-page :type='2'></carousel-page>
    <!-- 轮播图结束 -->
    <!-- 全域旅游生活服务平台 -->
    <!-- <introduce-page  :type='"全域旅游生活服务平台"' :url='"static/assets/images/feature/01.png"'></introduce-page> -->
    <section id='quanyulvyou' class="feature-area section-padding2">
      <div class="container">

        <div class="row flexJCenter">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-12">
                <div class="">
                  <h3 class='title borderABC'>全域旅游生活服务平台</h3>
                  <p class='titleShadow'>GLOBAL TOURISM LIFE SERVICE PLATFORM</p>
                </div>
              </div>
            </div>
            <div class="mb-5">
              <p>
                实现本地化运营，搭建本地数字化运营平台、营销云平台、分销云平台、文旅大数据指挥云平台、车辆监管平台、年卡运营平台、景区票务平台、政府产业监管平台等八大平台版块。依托于数字化平台为安阳市打造全域文旅智慧解决方案（安阳文旅公共服务中心），并集合本地资源推出相关产品线上数字化运营。
              </p>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mb-3">
              <img style='width: 100%;' src="static/assets/images/service/01.png" alt="企业介绍">
            </div>
          </div>

        </div>
      </div>
    </section>
    <!-- 全域旅游生活服务平台结束 -->
    <!-- 全域服务对象-->
    <section id='quanyufuwu' class="feature-area section-padding2" style='background-color: #f7fafd;'>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>全域服务对象</h2>
              <p class='titleShadow'>GLOBAL SERVICE OBJECT</p>
            </div>
          </div>
        </div>
        <div class="row" style='justify-content: space-between;'>
          <div class="col-lg-3" v-for='item in serviceDXList'>
            <div class='serviceDX'>
              <div class='serviceDXT'>
                <img style='width: 40px;' :src="item.icon" alt="联系我们">
                <h4>{{item.name}}</h4>
              </div>
              <p class='serviceDXP'>{{item.text}}</p>

            </div>
          </div>
        </div>
      </div>

    </section>
    <!-- 全域服务对象结束-->
    <!-- 八大平台支撑-->
    <section id='badapingtai' class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>八大平台支撑</h2>
              <p class='titleShadow'>EIGHT PLATFORM SUPPORT</p>
            </div>
          </div>
        </div>
        <div class="row" style='justify-content: space-between;'>
          <div class="col-lg-4" v-for='item in zcList'>
            <div class='serviceZC'>
                <img style='width: 100%;' :src="item.img" :alt="item.alt">
            </div>
          </div>
        </div>
      </div>

    </section>
    <!-- 八大平台支撑结束-->
    <!-- 本地化特色产品打造-->
    <section id='benditese' class="feature-area section-padding2" style='background-image: url(static/assets/images/service/bg.png);background-size: 100% 100%;'>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>本地化特色产品打造</h2>
              <p class='titleShadow'>LOCAL FEATURE PRODUCT CREATION</p>
            </div>
          </div>
        </div>
        <div>
          <div class="TbutBgWarp">
            <div class='TbutBg'>
              <div @click='cutCard=1' :class='cutCard==1?"Tbut1":"Tbut"'>旅游年卡</div>
              <div @click='cutCard=2' :class='cutCard==2?"Tbut1":"Tbut"'>旅游专线</div>
            </div>

          </div>
          <div class="row">
            <div class="col-lg-2 flexcc">
              <img class='butImg' @click='cutCard=1' :src="cutCard==1?'static/assets/images/service/l1.png':'static/assets/images/service/l2.png'" alt="">
            </div>
            <div class="col-lg-8">
              <img style='width: 100%;' v-show='cutCard == 1' src="static/assets/images/service/ts1.png" alt="">
              <img style='width: 100%;' v-show='cutCard == 2' src="static/assets/images/service/ts2.png" alt="">
            </div>
            <div class="col-lg-2 flexcc">
              <img class='butImg' @click='cutCard=2' :src="cutCard==2?'static/assets/images/service/r1.png':'static/assets/images/service/r2.png'" alt="">
            </div>
          </div>


        </div>
      </div>
    </section>
    <!-- 本地化特色产品打造 结束 -->
    <!-- 全域分销一站式链条-->
    <section id='quanyufenxiao' class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>全域分销一站式链条</h2>
              <p class='titleShadow'>GLOBAL DISTEIBUTION ONE-STOP CHAIN</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <img style='width: 100%;' src="static/assets/images/service/12.png" alt="联系我们">
          </div>
        </div>
      </div>
    </section>
    <!-- 全域分销一站式链条 结束 -->
    <!-- 多渠道验证终端服务-->
    <section id='duoqudao' class="feature-area section-padding2" style='overflow: hidden;background-image:url("../static/assets/images/service/bg.png") ;background-size: 100% 100%;'>
      <!-- <img style='width: 100vw;z-index: -100;position: absolute;' src="static/assets/images/service/bg.png" alt="多渠道验证终端服务"> -->
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>多渠道验证终端服务</h2>
              <p class='titleShadow'>MULTI-CHANNEL VERIFCATION TERMINAL SERVIES</p>
            </div>
          </div>
        </div>
        <div class="row" style='justify-content: space-between;'>
          <div class="col-lg-4" v-for='item in zdList'>
            <div class='serviceZC'>
                <img style='width: 100%;' :src="item.img" :alt="item.alt">
                <h4 class='mt20'>{{item.alt}}</h4>
            </div>
          </div>
        </div>
      </div>

    </section>
    <!-- 多渠道验证终端服务结束-->
    <!-- 锚点-->
    <div class='SbgWarp'>
      <div class='bgtextTitle'>全域旅游服务商</div>
      <div class='fbgTextWarp'>
        <div @click='cutIndex(0)' :class='cutFbgTextIndex==0?"cutFbgTextItem":"fbgTextItem"'>全域旅游生活服务平台</div>
        <div @click='cutIndex(1)' :class='cutFbgTextIndex==1?"cutFbgTextItem":"fbgTextItem"'>全域服务对象</div>
        <div @click='cutIndex(2)' :class='cutFbgTextIndex==2?"cutFbgTextItem":"fbgTextItem"'>八大平台支撑</div>
        <div @click='cutIndex(3)' :class='cutFbgTextIndex==3?"cutFbgTextItem":"fbgTextItem"'>本地化特色产品打造</div>
        <div @click='cutIndex(4)' :class='cutFbgTextIndex==4?"cutFbgTextItem":"fbgTextItem"'>全域分销一站式链条</div>
        <div @click='cutIndex(5)' :class='cutFbgTextIndex==5?"cutFbgTextItem":"fbgTextItem"'>多渠道验证终端服务</div>
      </div>
    </div>
  </div>
</template>

<script>
  import carouselPage from './module/carousel.vue'
  import introducePage from './module/introduce.vue'
  export default {
    components:{carouselPage,introducePage},
    data(){
      return{
        cutCard:1,
        cutFbgTextIndex:0,
        zdList:[
          {
            img:'static/assets/images/service/17.png',
            alt:'景区手持机'
          },
          {
            img:'static/assets/images/service/14.png',
            alt:'景区闸机'
          },
          {
            img:'static/assets/images/service/15.png',
            alt:'景区人脸闸机'
          },
          {
            img:'static/assets/images/service/16.png',
            alt:'景区自助机'
          },
          {
            img:'static/assets/images/service/13.png',
            alt:'车载验证设备'
          },
          {
            img:'static/assets/images/service/18.png',
            alt:'商家验证端'
          }
        ],
        zcList:[
          {
            img:'static/assets/images/service/03.png',
            alt:'文旅大数据指挥云平台'
          },
          {
            img:'static/assets/images/service/04.png',
            alt:'本地数字化运营平台'
          },
          {
            img:'static/assets/images/service/05.png',
            alt:'景区票务平台'
          },
          {
            img:'static/assets/images/service/06.png',
            alt:'年卡运营平台'
          },
          {
            img:'static/assets/images/service/07.png',
            alt:'分销云平台'
          },
          {
            img:'static/assets/images/service/08.png',
            alt:'营销云平台'
          },
          {
            img:'static/assets/images/service/09.png',
            alt:'产业监管平台'
          },
          {
            img:'static/assets/images/service/10.png',
            alt:'车辆监管平台'
          },
          {
            img:'static/assets/images/service/11.png',
            alt:'其他'
          }
        ],
        serviceDXList:[
          {
            icon:'static/assets/images/service/icon01.png',
            name:'文旅单位',
            text:'为政府文旅主管部门、市县区各级文旅局提供数据流量监控、综合舆情分析等实时数据，打造全域智慧文旅数据指挥中心'
          },
          {
            icon:'static/assets/images/service/icon02.png',
            name:'本地运营商',
            text:'结合本地旅游景区资源、书屋文化、旅游巴士、酒店民宿、文创商家，汇聚优质品牌，创建品牌IP'
          },
          {
            icon:'static/assets/images/service/icon03.png',
            name:'本地市民',
            text:'解决本地居民日常消费环节，联合各生活元素，提供便民政策，创造惠民生活服务综合体'
          },
          {
            icon:'static/assets/images/service/icon04.png',
            name:'外地游客',
            text:'提供本地文化元素输出、旅游咨询详情、公共交通查询、特色伴手礼购买、酒店民宿入住、本地美食推荐，解决外来游客落地'
          },
          {
            icon:'static/assets/images/service/icon05.png',
            name:'景区',
            text:'服务本地景区智慧化提升，票务系统、验证终端、语音讲解、客流分析监控等综合系统，根据景区不同特色打造优质景区解决方案'
          },
          {
            icon:'static/assets/images/service/icon06.png',
            name:'车队',
            text:'根据不同客运企业，提供车载验证终端、GPS实时定位监控、运载力规划、客座率分析等服务功能'
          },
          {
            icon:'static/assets/images/service/icon07.png',
            name:'商家',
            text:'餐饮、商品、娱乐、特产、文创等商家推广宣传，进店消费核验、现场收银等环节共同服务，从引流宣传到转化成交，扩大商家知名度'
          },
          {
            icon:'static/assets/images/service/icon08.png',
            name:'旅行社',
            text:'地接、组团等业务互联网化，提供宣传平台、收客系统，对旅游产品营销，客户服务、客源分析体系搭建综合平台'
          }
        ]
      }
    },
    methods:{
      cutIndex(index){
        this.cutFbgTextIndex = index
        if(index == 0){
          const quanyulvyou = document.getElementById("quanyulvyou");
          quanyulvyou.scrollIntoView({ behavior: "smooth" });
        }else if(index == 1){
          const quanyufuwu = document.getElementById("quanyufuwu");
          quanyufuwu.scrollIntoView({ behavior: "smooth" });
        }else if(index == 2){
          const badapingtai = document.getElementById("badapingtai");
          badapingtai.scrollIntoView({ behavior: "smooth" });
        }else if(index == 3){
          const benditese = document.getElementById("benditese");
          benditese.scrollIntoView({ behavior: "smooth" });
        }else if(index == 4){
          const quanyufenxiao = document.getElementById("quanyufenxiao");
          quanyufenxiao.scrollIntoView({ behavior: "smooth" });
        }else if(index == 5){
          const duoqudao = document.getElementById("duoqudao");
          duoqudao.scrollIntoView({ behavior: "smooth" });
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// Service.vue?1d8ef42a